import { z } from "zod"

export const EmailReaderCompaniesResponseDataSchema = z.array(
  z.object({
    id: z.bigint().transform(String),
    name: z.string(),
    logo: z.string().nullable(),
    organizationId: z.bigint().transform(String),
    integrations: z.array(
      z.object({
        id: z.bigint().transform(String),
        email: z.string(),
      }),
    ),
  }),
)

export const EmailReaderMessagesResponseDataSchema = z.object({
  resultSizeEstimate: z.number(),
  nextPageToken: z.string().nullable(),
  messages: z.array(
    z.object({
      id: z.string(),
      threadId: z.string(),
      from: z.string().nullable(),
      to: z.string().nullable(),
      subject: z.string().nullable(),
      date: z.string().nullable(),
      snippet: z.string().nullable(),
      isRead: z.boolean(),
      labels: z.array(z.string()),
    }),
  ),
})

const EmailReaderThreadMessageSchema = z.object({
  id: z.string(),
  threadId: z.string(),
  from: z.string().nullable(),
  to: z.string().nullable(),
  subject: z.string().nullable(),
  date: z.string().nullable(),
  body: z.string().nullable(),
  snippet: z.string().nullable(),
  labels: z.array(z.string()),
})

export const EmailReaderThreadResponseDataSchema = z.object({
  threadId: z.string(),
  conversation: z
    .object({
      id: z.bigint().transform(String),
      customerId: z.bigint().transform(String),
      organizationId: z.bigint().transform(String),
    })
    .nullable(),
  messages: z.array(EmailReaderThreadMessageSchema),
})
